import MainModal from '@/common/components/base/modal/Modal';
import { MainModalProps } from '@/common/components/base/modal/Modal.type';
import Typography from '@/common/components/base/typography/Typography';
import { Box, Flex } from 'styled-system/jsx';
import InfoCircleIcon from '../../assets/icons/outlineInfoCircle.svg?react';
import Button from '@/common/components/base/button/Button';

export default function WalletInfoModal({
  closeModal,
  open,
  title,
  description,
  note,
}: MainModalProps & {
  description: string;
  note: string[];
}) {
  return (
    <MainModal
      title={title}
      titleLineColor={'purple-primary'}
      closeModal={closeModal}
      open={open}
    >
      <Flex flexDirection={'column'} gap={16} mt={-16} pb={8}>
        <Typography color={'black'}>{description}</Typography>
        <Flex
          gap={8}
          alignItems={'start'}
          bgColor={'#e9f0ff'}
          border={'1px solid {colors.blue}'}
          borderRadius={8}
          px={9}
          py={4}
          color={'blue'}
          css={{
            '& svg': { width: '20px', height: '20px' },
            '& svg path': { fill: 'currentColor' },
          }}
        >
          <Flex alignItems={'center'} height={32} flexShrink={0}>
            <InfoCircleIcon />
          </Flex>
          <Box>
            {note.map((line) => (
              <Typography key={line} fontSize={12} color={'blue'}>
                {line}
              </Typography>
            ))}
          </Box>
        </Flex>
        <Button mt={16} fullWidth onClick={closeModal}>
          متوجه شدم
        </Button>
      </Flex>
    </MainModal>
  );
}
